export default __webpack_public_path__ + "static/wedding-infographic-f9095ee4ef1ce058cfd5d43af50b7844.jpg";